import React from "react";
import OfferEditorCommon from "./OfferEditorCommon";

/*
 * Stage 2 - BU Head
 *
 * Stage 2 approver is loaded from Workflow Master for:
 * Business Unit + Division.
 *
 * Access is decided in OffersList using:
 * current_stage === 2 && stage2_email === logged-in email
 *
 * The editable field list is NOT declared here. It is passed in as
 * `editableFields` from OffersList, which always supplies EDITABLE_FIELDS.bu_head
 * — the same list the backend enforces via EDITABLE_FIELDS[editorRole]. A local
 * copy would be silently overridden by the `{...props}` spread and would drift
 * from the real policy, so there is exactly one place to change it.
 */

export default function BUHeadOfferEditor(props) {
  return (
    <OfferEditorCommon
      {...props}
      title="Edit Offer - BU Head"
      stageLabel="Stage 2 - Business Unit Head"
      showAllFields={true}
      note="Only BU Head-controlled commercial and offer fields are editable. The approver is resolved from Workflow Master."
    />
  );
}
